var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 361,
    viewBox: "0 0 361 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_323_1272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5 64.6999H241.5C245.9 64.6999 249.5 61.1 249.5 56.7C249.5 52.3 245.9 48.7 241.5 48.7H56.5C52.1 48.7 48.5 52.3 48.5 56.7C48.5 61.1 52.1 64.6999 56.5 64.6999Z",
    fill: "#2D2D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 90H298.3V27.3C298.3 12.2 286 0 270.9 0L27.3 0.1C12.2 0.1 0 12.3 0 27.4L0.1 184.7C0.1 199.8 12.3 212 27.4 212H35V270.7L92 213.7V274.6C92 289.7 104.2 301.9 119.3 301.9H266.6L325.3 360.6V302H332.9C348 302 360.2 289.8 360.2 274.7V117.3C360.3 102.3 348 90 333 90ZM87.4 196.7L82.9 201.2L50.3 233.8V212V196.7H35H27.3C20.7 196.7 15.3 191.3 15.3 184.7V27.4C15.3 20.8 20.7 15.4 27.3 15.4L270.9 15.3C277.5 15.3 282.9 20.7 282.9 27.3V90H249.4C249.4 89.9 249.4 89.8 249.4 89.7C249.4 85.3 245.8 81.7 241.4 81.7H56.4C52 81.7 48.4 85.3 48.4 89.7C48.4 94.1 52 97.7 56.4 97.7H100.2C95.6 102.1 92.6 108 92 114.7H56.5C54.3 114.7 52.3 115.6 50.8 117C49.3 118.4 48.5 120.4 48.5 122.7C48.5 127.1 52.1 130.7 56.5 130.7H92V147.7H56.5C54.3 147.7 52.3 148.6 50.8 150C49.3 151.4 48.5 153.4 48.5 155.7C48.5 160.1 52.1 163.7 56.5 163.7H92V196.7H87.4ZM345 274.7C345 281.3 339.6 286.7 333 286.7H310V323.8L277.4 291.2L272.9 286.7H119.3C112.7 286.7 107.3 281.3 107.3 274.7V212V196.7V163.7V147.7V130.7V117.4C107.3 116.5 107.4 115.6 107.6 114.7C108.8 109.3 113.6 105.3 119.3 105.3H283H298.3H333C339.6 105.3 345 110.7 345 117.3V274.7Z",
    fill: "#2D2D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.6 160.4V174.3H190.6V197.3H209.6V267.1H237.7V197.3H258.8L261.1 174.3H237.7V160C237.7 151.4 240.2 147.5 249 147.5H261.5V125.9C257.4 125.3 250.8 124.9 245.1 124.9C219 124.9 209.6 137.2 209.6 160.4Z",
    fill: "#2D2D95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_323_1272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360.3,
    height: 360.7,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.702fc18d.svg";
export { ForwardRef as ReactComponent };